<template>
	<div v-if="!loading" class="relative" v-click-outside="clickOutside">
		<div class="relative h-10">
			<input 
					@click="countClicks('Nowa Piłka: LUPA DESKTOP')" type="search" autoComplete="off" v-model="searchPhrase"  
					@focus="showResults = true" placeholder="Wyszukaj..." name="s" required="" @change="savePhrase"
					class="text-sm h-full pl-3 pr-8"
					aria-label="Wyszukaj">
			<button class="absolute p-1 right-3 top-1/2 -translate-y-1/2">
				<svg class="fill-text h-4 w-4" aria-hidden="true" role="img" focusable="false"
				     xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 28 28">
					<path
						d="M31.715 28.953c0.381 0.381 0.381 0.999 0 1.381l-1.381 1.381c-0.382 0.381-1 0.381-1.381 0l-9.668-9.668c-0.105-0.105-0.175-0.229-0.222-0.361-1.983 1.449-4.418 2.314-7.063 2.314-6.627 0-12-5.373-12-12s5.373-12 12-12c6.627 0 12 5.373 12 12 0 2.645-0.865 5.080-2.314 7.063 0.132 0.047 0.256 0.116 0.361 0.222l9.668 9.668zM12 4c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8c0-4.418-3.582-8-8-8z"></path>
				</svg>
			</button>
		</div>
		<div v-if="searchPhrase.length > 0 && showResults" class="bg-zt-light-full max-h-[590px] overflow-y-auto absolute z-10 top-[50px] rounded-zt border border-zt-light shadow-zt w-full">
			<a v-if="leaguesToShow.length > 0 && searchPhrase !== ''" v-for="(league, index) in leaguesToShow" :key="league.league_id"
			   :class="{ 'border-b-0' : index === leaguesToShow.length - 1 && cupsToShow.length === 0 }"
			   :href="league.href" class="hover:!bg-zt-light px-2 result no-default-style text-sm border-zt-light py-3 border-b flex items-center gap-x-[6px]">
				<img :src="`/wp-content/themes/zawodtyper/assets/images/kraje/${league.country_query_name}.svg`"
				     class="inline rounded-[2px] object-cover" alt="" width="15" height="11">
				<p class="name font-normal" :class="{ 'font-semibold underline' : league.href === currentUrl }">{{ league.name }}</p>
			</a>
			<a v-if="cupsToShow.length > 0 && searchPhrase !== ''" v-for="(league, index) in cupsToShow" :key="league.league_id"
			   :class="{ 'border-b-0' : index === cupsToShow.length - 1 && teamsToShow.length === 0 }"
			   :href="league.href" class="hover:!bg-zt-light px-2 result no-default-style text-sm border-zt-light py-3 border-b flex items-center gap-x-[6px]">
				<img :src="`/wp-content/themes/zawodtyper/assets/images/kraje/${league.country_query_name}.svg`"
				     class="inline rounded-[2px] object-cover" alt="" width="15" height="11">
				<p class="name font-normal" :class="{ 'font-semibold underline' : league.href === currentUrl }">{{ league.name }}</p>
			</a>
      <a v-if="supercupsToShow.length > 0 && searchPhrase !== ''" v-for="(league, index) in supercupsToShow" :key="league.league_id"
			   :class="{ 'border-b-0' : index === supercupsToShow.length - 1 && supercupsToShow.length === 0 }"
			   :href="league.href" class="hover:!bg-zt-light px-2 result no-default-style text-sm border-zt-light py-3 border-b flex items-center gap-x-[6px]">
				<img :src="`/wp-content/themes/zawodtyper/assets/images/kraje/${league.country_query_name}.svg`"
				     class="inline rounded-[2px] object-cover" alt="" width="15" height="11">
				<p class="name font-normal" :class="{ 'font-semibold underline' : league.href === currentUrl }">{{ league.name }}</p>
			</a>
			<a v-if="tournamentsToShow.length > 0 && searchPhrase !== ''" v-for="(tournament, index) in tournamentsToShow" :key="tournament.league_id"
			   :class="{ 'border-b-0' : index === cupsToShow.length - 1 && teamsToShow.length === 0 }"
			   :href="tournament.href" class="hover:!bg-zt-light px-2 result no-default-style text-sm border-zt-light py-3 border-b flex items-center gap-x-[6px]">
        <img v-if="tournament['icon']" :src="`${tournament['icon']}`"
             class="inline rounded-[2px] aspect-square transform-gpu" alt="" width="15" height="11">
        <img v-else :src="`/wp-content/themes/zawodtyper/assets/images/kraje/${tournament.country_query_name}.svg`"
             class="inline rounded-[2px] object-cover transform-gpu" alt="" width="15" height="11">
				<p class="name font-normal" :class="{ 'font-semibold underline' : tournament.href === currentUrl }">{{ tournament.name }}</p>
			</a>
			<a v-if="teamsToShow.length > 0 && searchPhrase !== ''" v-for="team in teamsToShow" :key="team.team_id"
			   :href="`/wyniki-pilka-nozna/druzyny/${team.query_name}/`" class="py-3 px-2  hover:bg-zt-light border-zt-light border-b last:border-b-0 result no-default-style flex items-center gap-x-[6px] text-sm">
				<img :src="`/wp-content/themes/zawodtyper/assets/images/druzyny/${team.query_name}.png`"
				     class="inline w-[15px] h-[15px] object-contain" alt="" width="15" height="15">
				<p class="name font-normal" :class="{ 'font-semibold underline' : `/wyniki-pilka-nozna/druzyny/${team.query_name}/` === currentUrl }">
          {{ getTeamName(team) }}
        </p>
			</a>
      <a v-if="rankingsToShow.length > 0 && searchPhrase !== ''" v-for="ranking in rankingsToShow"
			   :href="ranking.href" class="py-3 px-2  hover:bg-zt-light border-zt-light border-b last:border-b-0 result no-default-style flex items-center gap-x-[6px] text-sm">
				<img :src="`/wp-content/themes/zawodtyper/assets/images/rankingi/${ranking.country_query_name}.svg`"
				     class="inline w-[15px] h-[15px] object-contain" alt="" width="15" height="15">
				<p class="name font-normal" :class="{ 'font-semibold underline' : `/wyniki-pilka-nozna/druzyny/${ranking.query_name}/` === currentUrl }">
          {{ ranking.name }}
        </p>
			</a>
      <a v-if="statsToShow.length > 0 && searchPhrase !== ''" v-for="stat in statsToShow"
			   :href="stat.href" class="py-3 px-2  hover:bg-zt-light border-zt-light border-b last:border-b-0 result no-default-style flex items-center gap-x-[6px] text-sm">
				<img :src="`/wp-content/themes/zawodtyper/assets/images/ikony_football/${stat.img}`"
				     class="inline w-[15px] h-[15px] object-contain" alt="" width="15" height="15">
				<p class="name font-normal" :class="{ 'font-semibold underline' : `${stat.href}` === currentUrl }">
          {{ stat.name }}
        </p>
			</a>
			<div v-if="(teamsToShow.length === 0 && leaguesToShow.length === 0 && cupsToShow.length === 0
			 && supercupsToShow.length === 0 && tournamentsToShow.length === 0 && rankingsToShow.length === 0 &&
			  statsToShow.length === 0)
			 || this.searchPhrase === ''" class="text-center text-sm text-zt-more grid place-items-center">
				<p class="py-3 text-sm font-normal">Brak wyników wyszukiwania...</p>
			</div>
		</div>
	</div>
</template>

<script>
import {countClicks} from "../../../../assets/js/utils";

export default {
	name: 'LeftSidebarSearch',
	inject: ['WP'],
	data() {
		return {
			searchPhrase: '',
			highlightedLeagues: [],
			cups: [],
			loading: true,
			restLeagues: [],
			showResults: false,
      extraTournaments: [],
      supercups: [],
			teams: [],
      tournaments: [],
      nationalTeams: [],
      rankings: [
        {
          name: 'Ranking UEFA',
          href: '/ranking-uefa/',
          country_query_name: 'uefa'
       },
        {
          name: 'Ranking FIFA',
          href: '/ranking-fifa/',
          country_query_name: 'fifa'
        },
        {
          name: 'Najlepsi strzelcy',
          href: '/najlepsi-strzelcy-sezonu/',
          country_query_name: 'strzelcy'
        },
      ],
      statsPages: [
        {
          name: "Wszystkie statystyki",
          href: "/statystyki-pilkarskie/",
          img: "wszystkie_statystyki.svg",
        },
        {
          name: "Statystyki - Over/under",
          href: "/statystyki-pilkarskie-over-under/",
          img: "overunder.svg",
        },
        {
          name: "Statystyki - BTTS Obie strzelą",
          href: "/statystyki-btts-obie-druzyny-strzela/",
          img: "btts.svg",
        },
        {
          name: "Statystyki - Rzuty rożne",
          href: "/statystyki-rzutow-roznych/",
          img: "rozne.svg",
        },
        {
          name: "Statystyki - Kartki",
          href: "/statystyki-kartek/",
          img: "kartki.svg",
        },
        {
          name: "Statystyki - Rezultat 1x2",
          href: "/rezultat-1x2/",
          img: "1x2.svg",
        },
        {
          name: "Statystyki - 1. i 2. Połowa",
          href: "/statystyki-1-polowa-i-2-polowa-meczu/",
          img: "polowy.svg",
        },
        {
          name: "Statystyki - Łamaki HT/FT",
          href: "/statystyki-polowa-koniec/",
          img: "htft.svg",
        },
        {
          name: "Statystyki - Czyste konta",
          href: "/statystyki-czyste-konto/",
          img: "czyste_konto.svg",
        },
        {
          name: "Statystyki - Rzuty karne",
          href: "/rzuty-karne-statystyki/",
          img: "karne.svg",
        },
        {
          name: "Statystyki - Kwadranse goli",
          href: "/statystyki-goli-w-kwadransach/",
          img: "kwadranse.svg",
        },
        {
          name: "Statystyki - Posiadanie piłki",
          href: "/statystyki-posiadanie-pilki/",
          img: "posiadanie.svg",
        },
        {
          name: "Statystyki - Strzały na bramkę",
          href: "/statystyki-strzaly-na-bramke/",
          img: "strzaly.svg",
        },
        {
          name: "Statystyki - Spalone",
          href: "/statystyki-spalone/",
          img: "spalone.svg",
        },
        {
          name: "Statystyki - Faule",
          href: "/statystyki-faule/",
          img: "faule.svg",
        },
        {
          name: "Statystyki - Podania",
          href: "/statystyki-podania/",
          img: "podania.svg",
        },
        {
          name: 'Statystyki - Sędziowie',
          href: '/statystyki-sedziow/',
          img: 'sedziowie.svg',
        },
        {
          name: "Serie meczów",
          href: "/najdluzsze-serie/",
          img: "serie.svg",
        },
      ],
			clickOutside: {
				handler: () => { this.showResults = false },
				events: ['touchend', 'mouseup']
			},
		}
	},
	computed: {
		leaguesToShow() {
			const matchingMainLeagues = this.highlightedLeagues.filter(league => this.removeAccents(league.name.toLowerCase()).includes(this.removeAccents(this.searchPhrase.toLowerCase())));
			const matchingRestLeagues = this.restLeagues.filter(league => this.removeAccents(league.name.toLowerCase()).includes(this.removeAccents(this.searchPhrase.toLowerCase())));
			return [...matchingMainLeagues, ...matchingRestLeagues];
		},
		teamsToShow() {
      const searchPhrase = this.removeAccents(this.searchPhrase.toLowerCase());
      const matchingTeams = this.teams.filter(team => {
        return this.removeAccents(team.shortname.toLowerCase()).includes(searchPhrase)
          || this.removeAccents(team.name.toLowerCase()).includes(searchPhrase)
          || this.removeAccents(team.seo_name.toLowerCase()).includes(searchPhrase)
      });
      const matchingNationalTeams = this.nationalTeams.filter(team => {
        return this.removeAccents(team.shortname.toLowerCase()).includes(searchPhrase)
          || this.removeAccents(team.name.toLowerCase()).includes(searchPhrase)
          || this.removeAccents(team.seo_name.toLowerCase()).includes(searchPhrase)
      });
			return [...matchingTeams, ...matchingNationalTeams];
		},
		cupsToShow() {
			return this.cups.filter(cup => this.removeAccents(cup.name.toLowerCase()).includes(this.removeAccents(this.searchPhrase.toLowerCase())) ||
          'puchar '.includes(this.searchPhrase.toLowerCase()));
		},
    supercupsToShow() {
			return this.supercups.filter(supercup => this.removeAccents(supercup.name.toLowerCase()).includes(this.removeAccents(this.searchPhrase.toLowerCase())));
		},
    tournamentsToShow() {
      return this.tournaments.filter(tournament =>
          this.removeAccents(tournament.name.toLowerCase()).includes(this.removeAccents(this.searchPhrase.toLowerCase())) ||
          this.removeAccents(tournament.search_name.toLowerCase()).includes(this.removeAccents(this.searchPhrase.toLowerCase())));
    },
    rankingsToShow() {
      return this.rankings.filter(ranking => this.removeAccents(ranking.name.toLowerCase()).includes(this.removeAccents(this.searchPhrase.toLowerCase())));
    },
    statsToShow() {
      return this.statsPages.filter(stat => this.removeAccents(stat.name.toLowerCase()).includes(this.removeAccents(this.searchPhrase.toLowerCase())));
    },
		currentUrl() {
			return window.location.pathname;
		},
	},
	watch: {
		searchPhrase(newVal, oldVal) {
			if (newVal !== oldVal && !!newVal) {
				if (this.searchPhrase.length > 0) {
					this.showResults = true;
				}
				setTimeout(() => {
					this.markSearchDivFilters();
				}, 0);
			}
		}
	},
  mounted() {
    axios
      .post(this.WP.ajaxUrl, {
        endpoint: 'api_get_football_leagues_and_teams',
      })
      .then(response => {
        this.highlightedLeagues = response.data.data.leagues.highlighted_leagues;
        this.restLeagues = response.data.data.leagues.rest_leagues;
        this.teams = response.data.data.teams;
        this.cups = response.data.data.cups;
        this.nationalTeams = response.data.data.national_teams;
        this.tournaments = response.data.data.tournaments;
        this.supercups = response.data.data.supercups;
				this.loading = false;
				this.removePlaceholder(this.$attrs.component);
      });
  },
	methods: {
		removeAccents(str) {
			return str.normalize("NFD").replace(/\p{Diacritic}/gu, "").replace(/\u0142/g, "l")
		},
		countClicks,
		markSearchDivFilters() {
			const resultsDiv = document.querySelectorAll('.result');
			resultsDiv.forEach(node => {
				const fields = [
					{ selector: '.name', property: 'textContent' },
				];
				fields.forEach(({selector, property}) => {
					const fieldNode = node.querySelector(selector);
					if (!fieldNode) return;

					fieldNode.innerHTML = fieldNode.innerHTML.replace(/(<span class="bg-\[#6FAD6E99]">|<\/span>)/gi, '');

					const regex = this.generatePolishRegex(this.searchPhrase.toLowerCase());

					fieldNode.innerHTML = fieldNode.innerHTML.replace(regex, (match) =>
						'<span class="bg-[#6FAD6E99]">' + match + '</span>'
					);

				});
			});
		},
		generatePolishRegex(word) {
			const polishLetters = {
				'a': '[aą]',
				'ą': '[aą]',
				'c': '[cć]',
				'ć': '[cć]',
				'e': '[eę]',
				'ę': '[eę]',
				'l': '[lł]',
				'ł': '[lł]',
				'n': '[nń]',
				'ń': '[nń]',
				'o': '[oó]',
				'ó': '[oó]',
				's': '[sś]',
				'ś': '[sś]',
				'z': '[zżź]',
				'ź': '[zżź]',
				'ż': '[zżź]'
			};

			const regexWord = word.split('').map(char => {
				return polishLetters[char] ? polishLetters[char] : `[${char}]`;
			}).join('');

			return new RegExp(regexWord, 'i');
		},
		savePhrase() {
			if (this.searchPhrase !== '') {
				axios
					.post(this.WP.ajaxUrl, {
						endpoint: 'api_save_phrase',
						type: 'football_search',
						phrase: this.searchPhrase,
					})
			}
    },
    getTeamName(team) {
      const searchPhrase = this.removeAccents(this.searchPhrase.toLowerCase());
      if (team.shortname?.length === 0) {
        if (team.country === 'World') {
          return `${team.name} (reprezentacja)`;
        }
        return team.name;
      }
      if (team.country === 'World') {
        return  `${team.shortname} (reprezentacja)`;
      }
      return this.removeAccents(team.shortname.toLowerCase()).includes(searchPhrase) ? team.shortname : team.name;
    }
	},
}
</script>